import { render, staticRenderFns } from "./CollectionsIncluding.vue?vue&type=template&id=e1acb800&scoped=true&"
import script from "./CollectionsIncluding.vue?vue&type=script&lang=js&"
export * from "./CollectionsIncluding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1acb800",
  null
  
)

export default component.exports